import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';

import { AppService } from "../../../../../src/app/app.service";
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';

import { userTypes } from 'projects/icemedx-lib/src/login/login.config';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { externaldata } from '../../../../icemedx-lib/src/models/ehr/externaldata';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { user } from '../../../../icemedx-lib/src/models/common/user';

@Component({
  selector: 'app-listofdocuments',
  templateUrl: './listofdocuments.component.html',
  styleUrls: ['./listofdocuments.component.scss']
})
export class ListOfDocumentsComponent implements OnInit, OnChanges {
  @Input() fromDate: string;
  @Input() toDate: string;
  @Input() patient: string = "";
  documents: externaldata[] = [];
  usernameMap: Map<string, string> = new Map<string, string>();

  private hasAccess: boolean = true;

  constructor(private appSvc: AppService, private domainService: DomainService, private ptSvc: PatientService, private medCodeSvc: MedicalcodesService) {
  }

  ngOnInit() {
    let feaAccess = this.appSvc.getPermission(userTypes.USER_FEATURES.ufExternalDocuments).default_access;
    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.hasAccess = false;

      setTimeout(_ => {
        this.domainService.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      });
    } else {
      this.getDocuments();
    }
  }

  ngOnChanges(changeObj) {
    if (Iceutility.isdefined(changeObj.patient) && Iceutility.isdefined(changeObj.patient.previousValue)) {
      if (changeObj.patient.currentValue !== changeObj.patient.previousValue && this.hasAccess) {
        this.getDocuments();
      }
    }
  }

  private getDocuments() {
    if (Iceutility.isStringUndefinedNullOrEmpty(this.patient) && Iceutility.isStringUndefinedNullOrEmpty(this.appSvc.getCurrentPatient()))
      return;

    this.ptSvc.getPatientDocuments(!Iceutility.isStringUndefinedNullOrEmpty(this.patient) ? this.patient : this.appSvc.getCurrentPatient(), "", IceTypes.ACCOUNT_TYPE.actNone, (Iceutility.isdefined(this.fromDate) ? this.fromDate : ""), (Iceutility.isdefined(this.toDate) ? this.toDate : ""), "", "")
      .subscribe(
        data => {
          if (Iceutility.isdefined(data) && data.length > 0) {
            this.documents = data;
            this.documents.forEach(d => {
              this.getMemberName(d, d.modified_user);
              d["_sub_type"] = this.getSubtypeTitle(d, Iceutility.toLong(d.sub_type));
              d["_note_status"] = this.appSvc.GetNoteStatusTypeValue(d.note_status_type);
              d["_external_data_type"] = this.appSvc.valueToExternalTypeText(d.external_data_key/*To do fix should be type*/);
              d["_created_date"] = Iceutility.getDateTextEx(d.external_reference_date);
              d["_modified_date"] = Iceutility.getDateTextEx(d.modified);
            });
          }
        },
        error => {
          this.domainService.logMessage(IceTypes.LOGTYPE.ltError, "An error occurred while fetching documents");
        });
  }

  private getSubtypeTitle(document: externaldata, subType: number) {
    this.medCodeSvc.getCodes("SUBTYPE_ITEM", "", "", "", this.appSvc.getCurrentAccount(), this.appSvc.getCurrentAccountType())
      .subscribe(data => {
        if (Iceutility.isdefined(data)) {
          for (let iType = 0; iType < data.length; iType++) {
            let type = data[iType];

            if (Iceutility.isdefined(type["sub_type"])) {
              if (type["sub_type"] == subType) {
                document["_sub_type"] = type["title"];
                break;
              }
            }
          }
        }
    });
  }

  private getMemberName(document: externaldata, memberId: string) {
    if (this.usernameMap.has(memberId)) {
      document["_modified_user"] = this.usernameMap.get(memberId);
    } else {
      this.domainService.mapMembers(memberId).subscribe(
        data => {
          if (data == null) return;
          for (let imem = 0; imem < data.length; imem++) {
            let mem = <user>data[imem];
            document["_modified_user"] = mem.getdisplayname();
            this.usernameMap.set(memberId, document["_modified_user"]);
            break;
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  downloadDocument(document) {

  }
}
